import { useEffect } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Header from './Components/Header'
import { useAppDispatch } from './Hooks/useAppDispatch'
import { useAppSelector } from './Hooks/useAppSelector'
import { getToken, refresh } from './Redux/AdminSlice'
import AddItemScreen from './Screens/AddItemScreen'
import { Home } from './Screens/Home'
import LoginScreen from './Screens/LoginScreen'
import MarketScanDetails from './Screens/MarkedScanDetails'
import MarketScan from './Screens/MarketScan'
import MarketScanForm from './Screens/MarketScanForm'
import { NotAuthorized } from './Screens/NotAuthorized'
import OnboardingScreen from './Screens/OnboardingScreen'
import RegisterScreen from './Screens/RegisterScreen'
import { UploadTranslations } from './Screens/UploadTranslations'
import { WhatsAppResponses } from './Screens/WhatsAppResponses'

function App() {
  const token = useAppSelector<string>(getToken)
  const dispatch = useAppDispatch()
  useEffect(() => {
    if (!token) dispatch(refresh())
  }, [token])

  return (
    <div className='app'>
      <div className='body'>
        <BrowserRouter>
          <Header />
          <Routes>
            <Route path='/' element={<LoginScreen />} />
            <Route path='/home' element={<Home />} />
            <Route path='/onboarding' element={<OnboardingScreen />} />
            <Route path='/register' element={<RegisterScreen />} />
            <Route path='/add-item' element={<AddItemScreen />} />
            <Route
              path='/upload-translations'
              element={<UploadTranslations />}
            />
            <Route path='/whatsapp-responses' element={<WhatsAppResponses />} />
            <Route path='/market-scan' element={<MarketScan/>} />
            <Route path='/market-scan/:type' element={<MarketScanForm/>} />
            <Route path='/market-scan/details' element={<MarketScanDetails/>} />
            <Route path='/not-authorized' element={<NotAuthorized />} />
          </Routes>
        </BrowserRouter>
      </div>
    </div>
  )
}

export default App
